export default __webpack_public_path__ + "static/media/news16.7c54f4c8.jpg";